import WidgetView from 'views/dashboard/widgetView'
import template from 'text-loader!templates/dashboard/widget/welcomeWidget.html'

WidgetView.WelcomeWidget = WidgetView.extend({
  template: template
});

export default WidgetView.WelcomeWidget;

